module.exports = __webpack_public_path__ + "media/images/pc/page_common/purpose_hairmakeup-65972df2b803b3fd00e6c451cf30d497.png";